/** Copy for the Reserve vs Studio welcome-pack layout. */
export const RESERVE_VS_STUDIO_CONTENT = {
  brand: 'AXONALL RESERVE',
  headline: 'Reserve vs Studio',
  subtitle: 'A simple distinction',
  summary:
    'Reserve is the selective member circle; Studio is the private environment through which members access Axonall’s tools, systems, and member benefits.',
  reserve: {
    title: 'RESERVE',
    points: [
      {
        label: 'What it is',
        text: 'Axonall’s private circle of selected luxury travel advisors.',
      },
      {
        label: 'What it represents',
        text: 'Belonging, standards, recognition, and a shared vision for where high-value travel is heading.',
      },
      {
        label: 'What members gain',
        text: 'Professional exchange, intelligence, voice and influence, selected opportunities, and a more elevated relationship with Axonall.',
      },
      {
        label: 'Why it matters',
        text: 'Reserve is a selective member circle brought together by shared purpose, higher standards, and a role in shaping what comes next.',
      },
    ],
  },
  studio: {
    title: 'STUDIO',
    points: [
      {
        label: 'What it is',
        text: 'The private member space through which Reserve advisors access Axonall.',
      },
      {
        label: 'What it enables',
        text: 'Search, booking, account activity, curated inventory, selected Axonall AI-led tools, Carbon Wallet features, and Journey Artisan-backed bookings.',
      },
      {
        label: 'What members use it for',
        text: 'Day-to-day access, discovery, booking support, and working more efficiently with Axonall.',
      },
      {
        label: 'Why it matters',
        text: 'Studio is how members access Axonall’s tools, systems, and benefits through one private member environment.',
      },
    ],
  },
}
